export const BASE_MAMIPAY_PATH = '/singgahsini/api/mamipay/request';
